import { render, staticRenderFns } from "./createProject.vue?vue&type=template&id=2fd8e349&scoped=true&"
import script from "./createProject.vue?vue&type=script&lang=js&"
export * from "./createProject.vue?vue&type=script&lang=js&"
import style0 from "./createProject.vue?vue&type=style&index=0&id=2fd8e349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8e349",
  null
  
)

export default component.exports